<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'clients', 'name': 'Clients'}]" />
    <a-skeleton active :loading="loading_opt" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-button
        type="primary"
        shape="round"
        @click="showDrawer"
        style="margin-top:10px;margin-bottom:30px;"
      >Create new client</a-button>
    </a-skeleton>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allClients"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="client" :rowKey="client.uuid">
          <a
            @click="$router.push({ name: 'clientEdit', params: { uuid: client.uuid }})"
            slot="actions"
            style="color: rgba(0, 0, 0, 0.45) !important;"
          >
            <a-icon type="form" style="padding:5px;"></a-icon>Edit
          </a>
          <div class="container">
            <a-row type="flex" justify="space-around" align="middle">
            <b>ID:</b>
            <span class="client-id disabled">{{ client.client_id }}</span>
            <a-icon
              type="copy"
              style="fontSize:20px;cursor: pointer; padding:5px;"
              v-clipboard:copy="client.client_id"
              @click="success"
            />
            </a-row>
          </div>
          <a-list-item-meta
            class="clickable"
            @click="$router.push({ name: 'clientEdit', params: { uuid: client.uuid } })"
            :description="client.client_description"
          >
            <a slot="title">
              <b>{{ client.client_name }}</b>
            </a>
            <a-avatar slot="avatar" shape="square" :size="48" :src="client.branding_options.logo" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
    <a-create-client v-if="!loading_opt"/>
  </div>
</template>

<script>
import ACreateClient from "@/components/Drawer/ACreateClient";

export default {
  data() {
    return {
      loading: true,
      loading_opt: true,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      }
    };
  },
  components: {
    ACreateClient
  },
  methods: {
    success() {
      this.$message.success("Client id copied.", 5);
    },
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_client"
      });
    }
  },

  computed: {
    allClients() {
      return this.$store.state.tenant.clients;
    }
  },

  beforeCreate: async function() {
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "clients"
      });
      this.loading = false;
      try {
        await this.$store.cache.dispatch("tenant/getOptions", {
          endpoint: "clients"
        });
        this.loading_opt = false;
      } catch (error) {
        console.error(error);
        this.loading_opt = false;
      }
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.client-id {
  display: inline-block;
  width: 300px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  padding: 5px;
  margin-left: 5px;
}

.disabled {
  opacity: 0.7;
  overflow:hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
}
</style>
